import React, { Component } from 'react';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from 'react-accessible-accordion';
import YelpHeader from './Yelp/YelpHeader';
import YelpReviews from './Yelp/YelpReviews';
import toggleColorPicker from '../../Functions/toggleColorPicker';
import InfoPopup from '../InfoPopup';


class Yelp extends Component {
  constructor(props) {
    super(props);
    const { widget } = this.props;
    const { htmlData } = widget;

    this.state = {
      widget: {
        htmlData: {
          yelp: {
            url: decodeURIComponent(htmlData?.yelp?.url || ''),
            header: {
              yelpCompanyName: htmlData?.yelp?.header?.yelpCompanyName,
              headerStatus: htmlData?.yelp?.header?.headerStatus || 'on',
              headerFontFamily: htmlData?.yelp?.header.headerFontFamily || 'Montserrat',
              headerFontBold: htmlData?.yelp?.header.headerFontBold || 'on',
              headerFontItalic: htmlData?.yelp?.header.headerFontItalic || 'on',
              logoStatus: htmlData?.yelp?.header.logoStatus || 'on',
              companyNameStatus: htmlData?.yelp?.header.companyNameStatus || 'on',
              addReviewStatus: htmlData?.yelp?.header.addReviewStatus || 'on',
              reviewCountStatus: htmlData?.yelp?.header.reviewCountStatus || 'on',
              headerColor: htmlData?.yelp?.header.headerColor || '#333333',
              headerBgColor: htmlData?.yelp?.header.headerBgColor || '#ffffff',
              headerFontSize: htmlData?.yelp?.header.headerFontSize || '22',
              reviewButtonTextColor: htmlData?.yelp?.header.reviewButtonTextColor || '#ffffff',
              reviewButtonBgColor: htmlData?.yelp?.header.reviewButtonBgColor || '#d32323',
              reviewButtonHoverColor: htmlData?.yelp?.header.reviewButtonHoverColor || '#ffffff',
              reviewButtonHoverBgColor: htmlData?.yelp?.header.reviewButtonHoverBgColor || '#aa1b1b',
              reviewButtonFontSize: htmlData?.yelp?.header.reviewButtonFontSize || '16',
              reviewCountFontSize: htmlData?.yelp?.header.reviewCountFontSize || '16',
              reviewCountFontBold: htmlData?.yelp?.header?.reviewCountFontBold || 'on',
              reviewCountFontFamily: htmlData?.yelp?.header?.reviewCountFontFamily || 'Montserrat',
              reviewCountColor: htmlData?.yelp?.header?.reviewCountColor || "#333333",
              reviewButtonFontFamily: htmlData?.yelp?.header?.reviewButtonFontFamily || 'Montserrat',
            },
            button: {
              wordCountThreshold: htmlData?.yelp?.button?.wordCountThreshold || '50',
              readMoreStatus: htmlData?.yelp?.button?.readMoreStatus || 'on',
              readButtonTextColor: htmlData?.yelp?.button.readButtonTextColor || '#007bff',
              readButtonFontSize: htmlData?.yelp?.button.readButtonFontSize || '13',
              readButtonHoverColor: htmlData?.yelp?.button.readButtonHoverColor || '#aa1b1b',
              readButtonFontFamily: htmlData?.yelp?.button.readButtonFontFamily || 'Montserrat',
            },
            cards: {
              cardBgColor: htmlData?.yelp?.cards.cardBgColor || '#ffffff',
              cardBorderColor: htmlData?.yelp?.cards.cardBorderColor || '#e5e5e5',
              cardTextColor: htmlData?.yelp?.cards.cardTextColor || '#333333',
              cardtextFontSize: htmlData?.yelp?.cards.cardtextFontSize || '13',
              cardBorderRadius: htmlData?.yelp?.cards.cardBorderRadius || '8',
              reactionBarStatus: htmlData?.yelp?.cards.reactionBarStatus || 'on',
              reviewPhothoStatus: htmlData?.yelp?.cards.reviewPhothoStatus || 'off',
              cardtextFontFamily: htmlData?.yelp?.cards.cardtextFontFamily || 'Montserrat',
            },
            reviews: {
              reviewFilter: htmlData?.yelp?.reviews.reviewFilter || 'all',
              reviewlayout: htmlData?.yelp?.reviews.reviewlayout || 'list',
              reviewtextColor: htmlData?.yelp?.reviews.reviewtextColor || '#333333',
              containerBgColor: htmlData?.yelp?.reviews.containerBgColor || '#ffffff',
              containerBorderColor: htmlData?.yelp?.reviews.containerBorderColor || '#e5e5e5',
              reviewtextFontFamily: htmlData?.yelp?.reviews?.reviewtextFontFamily || 'Montserrat',
            },
            businessId: htmlData?.yelp?.businessId || '',
            companyName: htmlData?.yelp?.companyName || '',
            fetchReviews: htmlData?.yelp?.fetchReviews || '10',

          },
        },
        widgetType: widget.widgetType.id,
        widgetTypeName: widget.widgetType.name,
        widgetTypeScripts: widget.widgetType.scripts,
        title: widget.title,
        expires: widget.expires,
        isUrlChanged: true,
        isReloadRequired: true,
        isLoading: false,
        widgetId: widget.id,
      },
      previewHtml: '',
      fieldErrors: '',
      infoPopup: React.createRef()
    };
  }

  handleInputChange = async (e) => {

    const { type, name, value, checked } = e.target;
    const isUrlChange = name === 'url';
    const isFetchReviewChange = name === 'fetchReviews';
    const isbusinessIdChange = name === 'businessId'
    if (name === 'businessId' || name === 'fetchReviews') {
      this.setState((prevState) => ({
        widget: {
          ...prevState.widget,
          isUrlChanged: true,
          isLoading: true,
          isReloadRequired: true
        }
      }));
    } else {
      this.setState((prevState) => ({
        widget: {
          ...prevState.widget,
          isUrlChanged: false,
          isReloadRequired: false
        }
      }));
    }


    await this.setState((prevState) => ({
      widget: {
        ...prevState.widget,
        [name]: value,
        isUrlChanged: isUrlChange,
        isReloadRequired: isbusinessIdChange || isFetchReviewChange,
        htmlData: {
          ...prevState.widget.htmlData,
          [name]: value,
          yelp: {
            ...prevState.widget.htmlData.yelp,
            [name]: type === 'checkbox' ? (checked ? 'on' : 'off') : value,
            header: {
              ...prevState.widget.htmlData.yelp.header,
              [name]: (type == 'checkbox' ? (checked ? 'on' : 'off') : value),
            },
            button: {
              ...prevState.widget.htmlData.yelp.button,
              [name]: (type == 'checkbox' ? (checked ? 'on' : 'off') : value),
            },
            cards: {
              ...prevState.widget.htmlData.yelp.cards,
              [name]: (type == 'checkbox' ? (checked ? 'on' : 'off') : value),
            },
            reviews: {
              ...prevState.widget.htmlData.yelp.reviews,
              [name]: (type == 'checkbox' ? (checked ? 'on' : 'off') : value),
            },
          },
        },
      },
    }));

    const { previewWidget } = this.props;
    if (this.state.widget.htmlData.yelp.businessId) {
      await previewWidget(this.state.widget);
    }
    if (name === 'fetchReviews' || name === 'businessId') {
      this.setState((prevState) => ({
        widget: {
          ...prevState.widget,
          isLoading: false,
        }
      }));
    }
  }

  setColorsAndPreview = async (section, stateItem, value) => {
    await this.setState((prevState) => ({
      widget: {
        ...prevState.widget,
        isBusinessIdChanged: false,
        htmlData: {
          ...prevState.widget.htmlData,
          yelp: {
            ...prevState.widget.htmlData.yelp,
            [section]: {
              ...prevState.widget.htmlData.yelp[section],
              [stateItem]: value,
            }
          },
        },
      },
    }), async () => {

      const { previewWidget } = this.props;
      if (this.state.widget.htmlData.yelp.businessId) {

        const widgetTosend = { ...this.state.widget };
        widgetTosend.htmlData.yelp[section][stateItem] = value;
        widgetTosend.isReloadRequired = false;
        widgetTosend.isUrlChanged = false;
        await previewWidget(widgetTosend);
      }
    });

  };

  async componentDidMount() {
    const { previewWidget } = this.props;
    if (this.state.widget.htmlData.yelp.businessId) {
      await previewWidget(this.state.widget);
    }
  }

  render() {
    const { widget } = this.state;
    const { selectedEditor } = this.props;

    const { title } = widget;
    const { yelp } = widget.htmlData;

    const yelpSetupSteps = `
  <h2>Step-by-Step Guide to Find and Add Your Yelp Business ID:</h2>
  <ol>
    <li>Visit Your Yelp Business Page: Go to <strong>https://www.yelp.com</strong> and search for your business name. For example: <br />
        <code>https://www.yelp.com/biz/todd-patterson-coldwell-banker-a-hartwig-company-lancaster</code></li>
    
    <li>Click on "Write a Review": On your Yelp business page, locate the <strong>"Write a Review"</strong> button (usually in red). Click it.</li>

    <li>Copy the Business ID from the URL: After clicking the review button, the page will redirect and your browser's URL will look like this:<br />
        <code>https://www.yelp.com/writeareview/biz/PiuPPqHGDhY5JLO4G4fWzQ?return_url=...</code><br />
        Your Business ID is the part <strong>between</strong> <code>/biz/</code> and the <code>?</code><br />
        <strong>Example Business ID:</strong> <code>PiuPPqHGDhY5JLO4G4fWzQ</code>
    </li>

    <li>Paste the Business ID: Copy the ID and paste it into the "Yelp Business ID" input field in our widget editor panel.</li>

    <li>We’ll Handle the Rest: Once you've entered the Business ID, our system will automatically fetch and display your reviews in the widget.</li>
  </ol>
`;



    return (
      <div className="mjwi-editor-main-inner">
        {selectedEditor === 'Builder' && (
          <div className="mjwi-editor-builder">
            <label htmlFor="title">Widget Name</label>
            <input
              type="text"
              name="title"
              value={title}
              placeholder="Title"
              onChange={this.handleInputChange}
            />
            <label htmlFor="businessId">Yelp Business ID * <i onClick={() => this.state.infoPopup.current.openPopup()} className="fa-solid fa-circle-info"></i></label>
            <input
              type="text"
              name="businessId"
              placeholder='Enter Business ID eg. PiuPPqHGDhY5JLO4G4fWzQ'
              value={yelp.businessId}
              onChange={this.handleInputChange}
            />
            <label htmlFor="url">
              Yelp Business URL
            </label>
            <input
              type="text"
              name="url"
              value={yelp.url}
              placeholder="https://www.yelp.com/biz/todd-patterson-coldwell-banker-a-hartwig-company-lancaster"
              onChange={this.handleInputChange}
            />
            <label htmlFor="companyName">
              Yelp Business Name
            </label>
            <input
              type="text"
              name="yelpCompanyName"
              placeholder='Enter your Custome Business Name'
              value={yelp.header.yelpCompanyName || ''}
              onChange={this.handleInputChange}
            />

            <div className="mjwi-widget-loader-overlay">
              <label htmlFor="fetchReviews">
                Get More Reviews
                {this.state.widget.isLoading && (
                  <span>
                    <svg className="mjwi-widget-loading-spinner" viewBox="0 0 50 50">
                      <circle
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        stroke="#d32323"
                        strokeWidth="5"
                        strokeLinecap="round"
                        strokeDasharray="31.4 31.4"
                      />
                    </svg>
                  </span>
                )}
              </label>
            </div>
            <select
              name="fetchReviews"
              value={yelp.fetchReviews}
              onChange={this.handleInputChange}
            >
              {Array.from({ length: 9 }, (_, i) => (i + 1) * 5).map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>

            <InfoPopup ref={this.state.infoPopup} info={yelpSetupSteps} />
          </div>
        )}
        {selectedEditor === 'Layout' && (
          <div className="mjwi-editor-layout">
            <Accordion allowZeroExpanded={true}>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>Header</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <YelpHeader
                    widget={widget}
                    handleInputChange={this.handleInputChange}
                    toggleColorPicker={toggleColorPicker}
                    setColorsAndPreview={this.setColorsAndPreview}
                  />
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>All Reviews</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <YelpReviews
                    widget={widget}
                    handleInputChange={this.handleInputChange}
                    toggleColorPicker={toggleColorPicker}
                    setColorsAndPreview={this.setColorsAndPreview}
                  />
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        )}
      </div>
    );
  }
}

export default Yelp;